// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store' //引入store
//import css   游集市 采用  vue-beauty  UI框架
import 'vue-beauty/package/style/vue-beauty.min.css'
import '../static/css/reset.css'; //重置css
//import components
import vueBeauty from 'vue-beauty'
Vue.use(vueBeauty)
    //  '安装 vue-clipboard2  实现 复制粘贴'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 图片懒加载
import VueLazyLoad from 'vue-lazyload';
import appConstants from './utils/appConstants'
//全局常量
Vue.prototype.getAppConstants=()=>appConstants;
Vue.use(VueLazyLoad,{
  error:'../static/image/img-loading-default.png',//加载错误时的显示图片
  loading:'../static/image/img-loading-default.png'//加载过程中的过渡图片
})
    // 导入所有过滤器
import './filters'
Vue.prototype.replaceBr = function replaceBr(value) {
    if (value == null) {
        return;
    }
    return value.replace(/\n|\r\n/g, "<br/>").replace(/width/g, "max-width")
};
// 项目配置
import Config from "./utils/IPconfig";
const config = new Config();
Vue.prototype.api = config.api;
Vue.prototype.$config = config;
console.log("%c基础配置：", "color:#f00", config);


//  ‘封装 axios 方法’
import {
    post,
    fetch,
    patch,
    put
} from './utils/http'
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

// 用于Vue组件的延迟渲染,改善初次进入页面或者数据量较大的页面操作时出现卡顿的情况
import LazyRender from 'vue-lazy-render'
Vue.use(LazyRender)

//  '引入 百度地图'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
    ak: 'jyWRSsLHc8uIbRf8EVgstpxZpMGr9LnR'
})

// '添加  vue-localstorage 本地存储插件'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

/**
 *
 * Use localStorage from Vue object   // this.$localStorage.set('someBoolean',true)
    Vue.localStorage.set('someNumber', 123)
    Vue.localStorage.get('someNumber')

 */

//  添加 字符串  截断 插件   {{ text | truncate(100) }}
var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

Vue.config.productionTip = false;


/* eslint-disable no-new */
//获取缩略图地址
Vue.prototype.getTargetImageUrl=function(url,width,height) {
  if (url) {
    var targetUrl=url;
    if ( url.indexOf('//')===0){
      targetUrl =  'https:'+ url;
    }
    var index = targetUrl.lastIndexOf("http://");
    if (index < 0) {
      index = targetUrl.lastIndexOf("https://");
    }
    if (index > 0) {
      targetUrl =targetUrl.substring(index, targetUrl.length);
    }
    if(width>0 && height>0){
      targetUrl=targetUrl+ '?x-oss-process=image/resize,m_fill,h_'+ height + ',w_'+ width;
    }
    return targetUrl;
  }
  return url;
}





new Vue({
  store,
  router,
  el: '#app',
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js